<div class="py-5 vh-100 d-flex justify-content-center align-items-center">
  <div class="container">
    <img
      src="assets/images/bgs/Under construction-cuate.png"
      class="img-fluid d-block mx-auto col-12 col-md-4"
      alt="under construction"
    />
    <h2
      translate="under_construction"
      class="text-align-center fw-600 text-primary"
    ></h2>
    <p
      translate="page_not_available_now"
      class="text-align-center fs-6 text-info"
    ></p>

    <button
      type="button"
      [routerLink]="['/']"
      translate="return_home"
      class="btn btn-primary text-white d-block mx-auto mt-4 rounded-8 px-4 py-2 text-capitalize"
    ></button>
  </div>
</div>
